/**
 * Badges statut famille / métier taxonomie.
 */
export default function TaxonomyStatusBadge({ entity }) {
  if (!entity) return null;
  const badges = [];

  if (entity.archivedAt) {
    badges.push({ label: 'Archivé', className: 'bg-gray-200 text-gray-700' });
  } else if (entity.deprecated) {
    badges.push({ label: 'Deprecated', className: 'bg-amber-100 text-amber-800' });
  } else if (entity.actif === false) {
    badges.push({ label: 'Inactif', className: 'bg-red-100 text-red-700' });
  } else {
    badges.push({ label: 'Actif', className: 'bg-green-100 text-green-800' });
  }

  if (entity.system) {
    badges.push({ label: 'Système', className: 'bg-indigo-100 text-indigo-800' });
  }

  return (
    <span className="inline-flex flex-wrap gap-1">
      {badges.map((b) => (
        <span
          key={b.label}
          className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${b.className}`}
        >
          {b.label}
        </span>
      ))}
    </span>
  );
}
